export function writeQueue(worker, payload = Infinity) {
    const queue = [];
    let isProcessing = false;
    async function process() {
        if (isProcessing || queue.length === 0)
            return;
        isProcessing = true;
        const tasksToProcess = queue.splice(0, payload);
        const updates = tasksToProcess.map(item => item.task);
        const result = await worker(updates);
        tasksToProcess.forEach(task => task.resolve(result));
        isProcessing = false;
        void process();
    }
    return {
        push(task) {
            return new Promise((resolve) => {
                queue.push({ task, resolve });
                void process();
            });
        }
    };
}
